export const TAG_IDENTIFIER = "tagIdentifier";
export const DISPLAY_LABEL = "displayLabel";
export const LICENSE_SCOPE = "licenseScope";
export const HELPER_TEXT = "helperText";
